module.exports = __webpack_public_path__ + "img/fire_mob.c369026.svg";